<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="关键词">
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="名称、编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status">
              <el-option key="1" label="启用" :value="1"></el-option>
              <el-option key="2" label="禁用" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <mytable :list="list" :category="category"></mytable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import mytable from './table.vue'
import { commodityList } from '../../../service/getData'
export default {
  props: {
    category: {
      type: Number,
      default: 1,
    },
  },
  components: {
    mytable,
  },
  data() {
    return {
      filter: {
        admin: true,
        page: 1,
        size: 10,
        query: '',
        status: '',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.query = ''
        this.filter.status = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1
      params.category = this.category

      let res = await commodityList(params)
      if (res.code == 0) {
        this.tableCategory = params.category
        this.list = res.data.list
        this.total = res.data.count
      }
    },
  },
}
</script>